module.exports = __webpack_public_path__ + "img/mark_pop.0deff1fc.png";